import * as React from 'react';
import { Icon } from 'react-icons-kit';

export default class FeatureStatComponent extends React.Component<any, any> {
    
    constructor(props:any) {
        super(props);
    }

    render() {
        return (
            <div className='chartContainer featureStat'>
                <div id='featureStatIconContainer' className={this.props.iconClassName}><Icon size={32} icon={this.props.icon}/></div>
                <div id='featureStatDataContainer' className={this.props.statClassName}>
                    <p id='fstat'>{this.props.stat}</p>
                    <p id='fdesc'>{this.props.desc}</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/analytics/dashboardComponents/FeatureStatComponent.tsx